import { useState } from 'react';
import { useSelector } from 'react-redux';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import DefaultPopup from '@r1-frontend/ui-react/components/popups/defaultPopup';
import { InfoCircleFlip } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { getPluralize } from '@r1-frontend/shared/helpers/pluralize';

import { useAnalytics } from '~/src/features/full-buy/analytics/context';
import {
    getSubscriptionsSummary,
} from '~/src/features/full-buy/store/selectors/getSubscriptionsSummary/getSubscriptionsSummary';

export const WantMoreSubscriptions = () => {
    const analytics = useAnalytics();

    const [isOpen, changePopupState] = useState(false);
    const currentTariff = useSelector(getSubscriptionsSummary);
    const handleClosePopup = () => {
        changePopupState(false);
    };
    const handleOpenPopup = () => {
        changePopupState(true);
        analytics.subscriptions.clickMoreSubscriptions();
    };
    const onClick = () => {
        analytics.initializationByTariffLine(String(currentTariff?.nextStep.speed));
        handleClosePopup();
    };
    const getSubscriptionText = (count: number, index: number) => {
        return `${count} ${getPluralize(['подписка', 'подписки', 'подписок'])(count)}${currentTariff?.subscriptionsSummary?.length === index + 1 ? '.' : ','}`;
    };

    if (!currentTariff) {
        return null;
    }

    return (
        <>
            <Paragraph4>
                Подписки уже входят в&nbsp;стоимость тарифа. Каждый месяц их&nbsp;можно менять. {' '}
                {!currentTariff.isLast && (
                    <ControlElement Icon={InfoCircleFlip} onClick={handleOpenPopup}>Хочу больше подписок</ControlElement>
                )}
            </Paragraph4>

            <DefaultPopup isOpen={isOpen} onClose={handleClosePopup}>
                <IndentContainer $desktop={[32]} $mobile={[24]}>
                    <TextWrapper>
                        <H3 style={{ marginRight: 45 }}>Больше подписок</H3>
                        <Paragraph4 $color={COLORS.TextInfo}>
                            Чем быстрее интернет, тем больше подписок в&nbsp;тарифе:
                        </Paragraph4>
                    </TextWrapper>
                    {currentTariff.subscriptionsSummary.map((item, index) => {
                        return (
                            <Paragraph4
                                $withIndent={currentTariff.subscriptionsSummary.length === index + 1}
                                $color={item.active ? COLORS.TextPrimary : COLORS.TextInfo}
                                key={item.alias}
                            >
                                {item.active
                                    ? <b>{item.speed} Мбит/с &mdash; {getSubscriptionText(item.cnt, index)}</b>
                                    : <>{item.speed} Мбит/с &mdash; {getSubscriptionText(item.cnt, index)}</>
                                }
                            </Paragraph4>
                        );
                    })}
                    <ButtonGroup>
                        <a href={`/full-buy?tariffName=${currentTariff.nextStep.alias}`} onClick={onClick}>
                            <Button bType={'action'} size={'large'} onClick={onClick}>
                                Подключить {currentTariff.nextStep.speed} Мбит/с
                            </Button>
                        </a>
                        <Button bType={'secondary'} size={'large'} onClick={handleClosePopup}>Закрыть</Button>
                    </ButtonGroup>
                </IndentContainer>
            </DefaultPopup>
        </>
    );
};
